// extracted by mini-css-extract-plugin
export var backgroundContainer = "index-module--backgroundContainer--hjxz4";
export var card = "index-module--card--34I7e";
export var cardContainer = "index-module--cardContainer--RrtBg";
export var container = "index-module--container---BXxC";
export var description = "index-module--description--3CEWi";
export var image = "index-module--image--L2xqH";